export const notifySubscribers = <T>(eventName: string, detail: T): void => {
  let event: CustomEvent;

  if (typeof CustomEvent === 'object') {
    // IE11 DIE!
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
  } else {
    // Modern browsers
    event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);
  }
};
